export var warningBoxStyles={root:{backgroundColor:'#EFF6FC'},icon:{color:'#333333'},text:{color:'#333333'}};